import withModal from 'src/hoc/withModal'

import DeleteDialog from './DeleteDialog'

export default withModal(DeleteDialog)
